import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceSpaces',
    standalone: false
})
export class ReplaceSpacesPipe implements PipeTransform {

  transform(value: string, replaceWith: string = '-'): string {
    if (!value) { return ''; }
    return value.replace(/\s+/g, replaceWith);
  }
}
